import { inventorySnapshotsContracts } from "./inventory-snapshots.contract";
import { gainsRawDataSearchContracts } from "./gains-raw-data-search.contract";
import { supplierProductsContracts } from "./supplier-products.contract";
import { productSupercedesContracts } from "./product-supercedes.contract";
import { supplierWarehouseConstraintsContracts } from "./supplier-warehouse-constraints.contract";
import { replenishmentSuggestionsContracts } from "./replenishment-suggestions.contract";
import { queryBuilderContracts } from "./query-builder.contract";
import { procSavedReportsContracts } from "./saved-reports.contract";
import { inventoryPolicyOverridesContracts } from "./inventory-policy-overrides.contract";
import { returnCandidatesContracts } from "./return-candidates.contract";
import { demandOverridesContracts } from "./demand-overrides.contract";

export const procurementContracts = {
  inventorySnapshots: inventorySnapshotsContracts,
  gainsRawData: gainsRawDataSearchContracts,
  supplierProducts: supplierProductsContracts,
  productSupercedes: productSupercedesContracts,
  supplierWarehouseConstraints: supplierWarehouseConstraintsContracts,
  replenishmentSuggestions: replenishmentSuggestionsContracts,
  queryBuilder: queryBuilderContracts,
  savedReports: procSavedReportsContracts,
  inventoryPolicyOverrides: inventoryPolicyOverridesContracts,
  returnCandidates: returnCandidatesContracts,
  demandOverrides: demandOverridesContracts,
} as const;

export * from "./inventory-snapshots.contract";
export * from "./gains-raw-data-search.contract";
export * from "./supplier-products.contract";
export * from "./product-supercedes.contract";
export * from "./supplier-warehouse-constraints.contract";
export * from "./replenishment-suggestions.contract";
export * from "./query-builder.contract";
export * from "./saved-reports.contract";
export * from "./inventory-policy-overrides.contract";
export * from "./return-candidates.contract";
export * from "./demand-overrides.contract";
